export const headingStyle = {
  fontSize: ["40px", "40px", "48px"],
  lineHeight: ["40px", "40px", "48px"],
  textAlign: "center",
  px: "2",
  py: ["12px", "12px", "24px"]
};

export const heroLandingStyles = {
  mobile: {
    flex: {
      flexWrap: "wrap",
      alignSelf: "flex-end",
      p: "2"
    },
    text: {
      variant: "text.h1",
      color: "samoyedWhite"
    }
  },
  nonMobile: {
    flex: {
      m: "auto",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      width: "100%"
    },
    text: {
      fontWeight: "700",
      fontSize: "64px",
      lineHeight: "70px",
      textAlign: "center",
      color: "samoyedWhite",
      px: "30px"
    }
  },
  boxButton: {
    p: ["16px", "20px"],
    right: 0,
    bottom: 0,
    left: 0,
    position: ["fixed", "initial"],
    zIndex: 1,
    backgroundColor: ["white", "transparent"],
    borderTop: ["0.5px solid grey", "none"]
  },
  button: {
    px: ["0", "140px"],
    py: 2,
    width: "100%",
    borderRadius: "6px",
    variant: "primary",
    fontSize: ["18px", "24px"],
    fontWeight: 500,
    lineHeight: ["24px", "30px"]
  }
};

export const headlineStyles = {
  box: {
    referral: {
      px: [2, 2, "100px"],
      py: [4, 4, 8]
    },
    veterinarycover: {
      px: [2, 2, "100px"],
      py: [4, 4, 8]
    },
    recruitingsitters: {
      pl: [2, 2, "280px"],
      pr: [2, 2, "300px"],
      py: [4, 4, 4]
    },
    about: {
      px: [2, 2, "290px"],
      py: ["40px", "40px", "8"]
    },
    adviceforsitters: {
      px: [2, 2, "200px"],
      pt: [4, 4, 8],
      pb: ["10px", "10px", 3]
    },
    ourservices: {
      px: [2, 2, "200px"],
      pt: [4, 4, "80px"],
      pb: [4, 4, "76px"]
    }
  },
  title: {
    fontSize: ["30px", "30px", "32px"],
    lineHeight: 1.2
  },
  subtitle: {
    pt: ["12px", "12px", "1"],
    fontSize: "3",
    lineHeight: ["30px", "30px", "32px"]
  },
  boxButton: {
    mt: "35px"
  },
  button: {
    px: "140px",
    py: "2",
    width: ["100%", "initial"],
    fontSize: ["18px", "24px"],
    fontWeight: 500,
    lineHeight: ["24px", "30px"]
  }
};

export const textWithImgStyles = {
  flex: {
    flexWrap: "wrap",
    flexGrow: 1,
    width: "100%",
    color: "samoyedWhite"
  },
  boxTextLeft: {
    width: ["100%", "100%", "50%"],
    pt: [4, 4, 8],
    pb: [3, 3, 4],
    pl: [2, 2, 8],
    pr: [2, 2, 4]
  },
  boxTextRight: {
    width: ["100%", "100%", "50%"],
    pt: [4, 4, 8],
    pb: [3, 3, 4],
    pl: [2, 2, 8],
    pr: [2, 2, 4]
  },
  title: {
    mb: "4"
  },
  text: {
    whiteSpace: "pre-line"
  },
  boxImg: {
    width: ["100%", "100%", "50%"],
    height: ["320px", "320px", "inherit"],
    flexGrow: 1
  },
  img: {
    width: "100%",
    height: "100%",
    loading: "eager",
    priority: true,
    layout: "fill",
    objectFit: "cover"
  }
};

export const stepsGroupStyles = {
  flex: {
    veterinarycover: {
      flexWrap: "wrap",
      px: ["2", "2", "104.5px"],
      py: ["4", "4", "64px"]
    },
    recruitingsitters: {
      flexWrap: "wrap",
      px: ["2", "2", "115.5px"],
      py: ["4", "4", "64px"]
    },
    advicefor: {
      flexWrap: "wrap",
      px: ["2", "2", "340px"],
      pt: ["4", "4", "7"],
      pb: ["44px", "44px", "7"]
    },
    dogminder: {
      flexWrap: "wrap",
      px: ["2", "2", "245px"],
      py: ["4", "4", "4"]
    }
  },
  heading: {
    fontSize: ["30px", "30px", "32px"],
    lineHeight: ["30px", "30px", "32px"],
    fontWeight: 600
  },
  mainBoxLeft: {
    width: ["100%", "100%", "50%"],
    mb: ["4", "4", 0],
    pr: [0, 0, "5"]
  },
  mainBoxRight: {
    width: ["100%", "100%", "50%"],
    pl: [0, 0, "5"],
    borderLeft: [0, 0, "solid 1px lightGrey"]
  },
  mainBoxUnique: {
    width: ["100%", "100%", "100%"]
  }
};

export const simpleStepStyles = {
  flex: {
    mt: "3",
    alignItems: "center"
  },
  boxIcon: {
    width: "24px",
    height: "24px"
  },
  boxText: {
    width: "90%"
  },
  text: {
    pl: "12px"
  },
  stepIcon: {
    fontSize: "11px",
    color: "white",
    textAlign: "center",
    backgroundColor: "inuOrange",
    borderRadius: "circle",
    width: "24px",
    height: "24px",
    lineHeight: "24px"
  }
};

export const howToStepsStyles = {
  mainBox: {
    px: [2, 2, "100px"],
    pt: [4, 4, 8],
    pb: "40px",
    backgroundColor: "springGreen",
    color: "white"
  },
  mainBoxDefault: {
    px: [2, 2, "100px"],
    pt: [4, 4, 8],
    pb: "24px",
    backgroundColor: "springGreen",
    color: "white"
  },
  title: {
    mb: [0, 0, "4"],
    fontSize: ["30px", "30px", "32px"],
    lineHeight: ["30px", "30px", "32px"]
  },
  hr: {
    height: "3px",
    position: "absolute",
    border: 0,
    bg: "aquamarine",
    zIndex: 0,
    marginTop: "24px"
  },
  mainFlex: {
    flexWrap: "wrap",
    position: "relative",
    zIndex: 1,
    pb: "8"
  },
  mainFlexDefault: {
    flexWrap: "wrap",
    position: "relative",
    zIndex: 1,
    pb: "3"
  },
  feature: {
    flexMobile: {
      alignItems: "flex-start",
      mt: "3",
      ml: "1"
    },
    flex: {
      flexDirection: "column"
    },
    stepNumber: {
      margin: [0, 0, "auto"],
      fontSize: ["11px", "11px", "24px"],
      color: "white",
      textAlign: "center",
      backgroundColor: "aquamarine",
      borderRadius: "circle",
      width: [24, 24, 52],
      height: [24, 24, 52],
      lineHeight: ["24px", "24px", "52px"]
    },
    infoBox: {
      width: "90%",
      pl: ["12px", "12px", "0px"],
      pt: ["0px", "0px", "24px"]
    },
    infoTitle: {
      fontWeight: 600,
      fontSize: "16px",
      lineHeight: ["24px", "24px", "20px"]
    },
    infoDesc: {
      fontWeight: 400,
      lineHeight: "20px",
      pt: ["8px", "8px", "4px"]
    }
  },
  boxButton: {
    textAlign: "center",
    pt: "12px",
    pb: "4"
  },
  mainButton: {
    fontSize: "24px",
    lineHeight: "30px",
    fontWeight: 500,
    borderRadius: "6px",
    px: "140px",
    py: "16px",
    backgroundColor: "samoyedWhite",
    color: "springGreen",
    border: "1px solid",
    ":hover": {
      borderColor: "samoyedWhite",
      bg: "springGreen",
      color: "samoyedWhite"
    }
  }
};

export const stepDetailStyles = {
  serviceIcon: {
    p: "14px",
    bg: "transparent",
    border: "1px solid",
    borderColor: "labradorBlack",
    borderRadius: "24px",
    width: "79px",
    height: "79px",
    textAlign: "center"
  },
  box: {
    width: "75%",
    pl: "12px",
    flexDirection: "column",
    justifyContent: "center"
  },
  heading: {
    color: "springGreen",
    fontSize: "16px",
    lineWeight: "24px",
    fontWeight: "600"
  },
  headingBenefits: {
    color: "samoyedWhite",
    fontSize: "24px",
    lineWeight: "30px",
    fontWeight: "400",
    pb: "4px"
  },
  text: {
    mt: "12px"
  }
};

export const benefitsStyles = {
  ourservices: {
    box: {
      px: ["2", "2", "8"],
      py: ["4", "4", "8"],
      bg: "springGreen"
    },
    title: {
      fontSize: ["30px", "30px", "32px"],
      lineHeight: ["30px", "30px", "32px"],
      mb: "4",
      color: "samoyedWhite"
    }
  }
};
